import { render, staticRenderFns } from "./HelpDeskCard.vue?vue&type=template&id=36acfe7a&scoped=true"
import script from "./HelpDeskCard.vue?vue&type=script&lang=js"
export * from "./HelpDeskCard.vue?vue&type=script&lang=js"
import style0 from "./HelpDeskCard.vue?vue&type=style&index=0&id=36acfe7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acfe7a",
  null
  
)

export default component.exports